import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. Está pensado para quien recién está entrando al mundo de las inversiones.'
}, {
  q: '¿Esto son señales de compra/venta?',
  a: 'No. El Discord comparte análisis y actualizaciones — el objetivo es que aprendas a decidir vos.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato tras la compra.'
}, {
  q: '¿Cuánto tiempo tengo acceso al Discord?',
  a: '1 año de acceso desde el momento de la compra.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section className="bg-ink-950" data-id="element-63" data-mp="1z2dstd75t4iu">
      <Reveal data-id="element-64" data-mp="1z5jj2vriycg5">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-65" data-mp="sn3g8aizbrj8">
          Preguntas frecuentes
        </h2>
      </Reveal>

      <div className="mt-8 space-y-3" data-id="element-66" data-mp="nq4k5mfr9aie">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <Reveal key={f.q} delay={i * 0.05} data-id="element-67" data-mp="uh0vuaj10pnm" data-mpi={i}>
              <div className="overflow-hidden rounded-xl border border-white/10 bg-ink-900" data-id="element-68" data-mp="ufpt8e1bhny3">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors hover:bg-ink-850" data-id="element-69" data-mp="fiqfe8fvgyv6">
                  <span className="font-display text-sm font-semibold text-white sm:text-base" data-id="element-70" data-mp="6pvhjzsqi5ff">
                    {f.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-71" data-mp="3syo9o5jq8qyr" />
                </button>
                <AnimatePresence initial={false} data-id="element-72" data-mp="1smx1sk45pb0">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} data-id="element-73" data-mp="3jxq4vl1gsff4">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-gray-400" data-id="element-74" data-mp="1kqrvm1ow77uv">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </Reveal>;
      })}
      </div>
    </Section>;
}